<template>
  <ul class="breadcrumb">
    <li v-for="(crumb, index) in breadCrumbs" :key="index">
      <div v-if="crumb.to === undefined">
        <p>{{ translateText(crumb.text) }}</p>
      </div>
      <div v-else class="item-linked">
        <router-link :to="crumb.to" :title="crumb.tooltip ?? crumb.text">
          <p>{{ translateText(crumb.text) }}</p>
        </router-link>
        <font-awesome-icon icon="chevron-right" class="fa-xs" />
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: "BreadCrumb",
  components: {},
  data() {
    return {};
  },
  methods: {
    translateText(text) {
      if (text === "nz") {
        return "New Zealand";
      }
      if (text === "all") {
        return "All Plants";
      }

      return text[0].toUpperCase() + text.slice(1);
    },
  },
  computed: {
    breadCrumbs() {
      if (typeof this.$route.meta.breadCrumb === "function") {
        return this.$route.meta.breadCrumb.call(this, this.$route);
      }
      return this.$route.meta.breadCrumb;
    },
  },
};
</script>
<style lang="scss" scoped>
/* Style the list */
ul.breadcrumb {
  align-items: center;
  background-color: #eee;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
}

/* Display list items side by side */
ul.breadcrumb li {
  align-items: center;
  display: inline-flex;
  margin: 0 0.2rem 0;
  p {
    margin: 0;
  }
}
.item-linked {
  display: flex;
  gap: 0.2rem;
  align-items: center;
}
</style>
